const DASHBOARD_PREFIX = '/painel';
const STORAGE_KEY = 'whizr_acting_producer';

/** Cabeçalho que diz à API em nome de qual produtor o painel está atuando. */
export const ACTING_HEADER = 'X-Producer-Id';

/** Evento disparado quando a API recusa uma ação por falta de permissão da equipe. */
export const PANEL_PERMISSION_DENIED_EVENT = 'panel-permission-denied';

export function getActingProducerId() {
    try {
        return localStorage.getItem(STORAGE_KEY) || null;
    } catch {
        return null;
    }
}

export function setActingProducerId(producerId) {
    try {
        localStorage.setItem(STORAGE_KEY, String(producerId));
    } catch { /* storage indisponível: o painel simplesmente não abre como membro */ }
}

export function clearActingProducer() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch { /* nada a limpar */ }
}

export function isPanelPath(pathname = window.location.pathname) {
    return pathname === DASHBOARD_PREFIX || pathname.startsWith(`${DASHBOARD_PREFIX}/`);
}

/**
 * Só as chamadas feitas de dentro do painel carregam o cabeçalho: o resto do
 * site (carteira, perfil, eventos) segue falando como a própria pessoa.
 */
export function actingHeaders() {
    const producerId = getActingProducerId();

    if (!producerId || !isPanelPath()) return {};

    return { [ACTING_HEADER]: producerId };
}
